import cn from 'classnames'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {mapIntervalNameToI18nKeyPlural, mapIntervalNameToI18nKeySingular} from '../..'
import messages from '../../../../../../../../../assets/messages'
import {getFormattedAmount} from '../../../../../../../../../common/utils/general'
import {PammOfferType} from '../../../../../../../../../graphql/types'
import {useStyles} from '../../styles'
import {InfoTooltip} from './components/InfoTooltip'
import {LargeText} from './components/LargeText'
import {PerformanceFee} from './components/PerformanceFee'

type OfferBodyProps = {
  offer: PammOfferType
} & WithNamespaces

export const _OfferBody = ({offer, t}: OfferBodyProps) => {
  const classes = useStyles()
  const {settings, currency} = offer

  return (
    <div className={classes.body}>
      <div className={classes.bodyColumn}>
        <div className={classes.infoTitle}>
          <Trans {...messages.feeStructureHeader} />
          <InfoTooltip content={t('feeStructureHeaderTooltip')} />
        </div>
        <div className={classes.feeTile}>
          {settings && settings.performanceFees && currency && (
            <PerformanceFee fees={settings.performanceFees} currency={currency} />
          )}
        </div>
      </div>
      <div className={classes.bodyColumn}>
        <div className={classes.text}>
          <Trans {...messages.tradingInterval} />
        </div>
        <div className={classes.text}>
          <LargeText>
            {settings?.tradingInterval?.count}{' '}
            <Trans
              {...(settings?.tradingInterval?.count === 1
                ? mapIntervalNameToI18nKeySingular
                : mapIntervalNameToI18nKeyPlural)[settings?.tradingInterval?.type ?? 0]}
            />
          </LargeText>
        </div>
      </div>
      <div className={classes.bodyColumn}>
        <div className={classes.text}>
          <Trans {...messages.minDeposit} />
        </div>
        <div className={cn(classes.text, classes.greenAmount, classes.amount)}>
          {getFormattedAmount({amount: settings?.minDeposit, currency})}
        </div>
      </div>
      <div className={classes.bodyColumn}>
        <div className={classes.text}>
          <Trans {...messages.minWithdrawal} />
        </div>
        <div className={cn(classes.text, classes.amount)}>
          {getFormattedAmount({amount: settings?.minWithdrawal, currency})}
        </div>
      </div>
      <div className={classes.bodyColumn}>
        <div className={classes.text}>
          <Trans {...messages.minInitialInvestment} />
        </div>
        <div className={cn(classes.text, classes.greenAmount, classes.amount)}>
          {getFormattedAmount({amount: settings?.minInitialInvestment, currency})}
        </div>
      </div>
    </div>
  )
}

export const OfferBody = withNamespaces()(_OfferBody)
